import { axiosInstance } from 'src/util/axios.js'

const useNotificationsApi = () => {
  const getNotificationsQuota = async () => {
    try {
      const response = await axiosInstance.post(
        '/blockchain-helpers/external/getOrCreateIndexerUser',
      )

      return response?.data?.data?.notificationsRemainingQuota || 10
    } catch (err) {
      console.error('Get notifications error', err)
      return []
    }
  }

  const getNotifications = async () => {
    try {
      const response = await axiosInstance.post('/blockchain-helpers/external/getAlertsForUser')

      return response.data.data
    } catch (err) {
      console.error('Get notifications error', err)
      return []
    }
  }

  const createNotification = async ({
    name,
    tokenAddress,
    toOrFrom,
    telegramChatId,
    email,
  }: {
    name: string
    tokenAddress: string
    toOrFrom: string
    telegramChatId: string
    email: string
  }) => {
    try {
      return await axiosInstance.post('/blockchain-helpers/createNotificationAlert', {
        name,
        tokenAddress,
        toOrFrom,
        telegramChatId,
        email,
      })
    } catch (err) {
      console.error('Remove notification error', err)
    }
  }

  const removeNotification = async (id: number) => {
    try {
      return await axiosInstance.post('/blockchain-helpers/deleteAlertForUser', {
        id,
      })
    } catch (err) {
      console.error('Remove notification error', err)
    }
  }

  return { getNotificationsQuota, getNotifications, createNotification, removeNotification }
}

export default useNotificationsApi
